export default "__VITE_ASSET__Br9$sR_5__"